import { api } from "api/api";
import { AxiosError } from "axios";
import Usuario from "model/administracao/cadastro/Usuario";
import Veiculo from "model/gestao/frotas/Veiculo";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Coleta from "model/transportes/coleta/Coleta";
import Mdfe from "model/transportes/mdfe/Mdfe";
import Rota from "model/transportes/rota/Rota";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class RotaService implements BaseServiceCadastros<Rota> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/rota/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Rota>((resolve, reject): void => {
            api
                .get(`/rota/consultar/${id}`)
                .then(response => {
                    const rota = response.data as Rota;

                    rota.itens.forEach(item => {
                        item.key = generateKey();
                    });
                    resolve(rota)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(rota: Rota) {
        return new Promise<Rota>((resolve, reject): void => {
            api
                .post(`/rota/incluir`, rota)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(rota: Rota) {
        return new Promise<Rota>((resolve, reject): void => {
            api
                .put(`/rota/editar`, rota)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/rota/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    mdfes() {
        return new Promise<Mdfe[]>((resolve, reject): void => {
            api
                .get(`/rota/mdfes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    coletas() {
        return new Promise<Coleta[]>((resolve, reject): void => {
            api
                .get(`/rota/coletas`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    veiculos() {
        return new Promise<Veiculo[]>((resolve, reject): void => {
            api
                .get(`/rota/veiculos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    motoristas() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/rota/motoristas`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListStatus() {
        return [
            { label: "Criada", value: "CRIADA" },
            { label: "Em andamento", value: "EM_ANDAMENTO" },
            { label: "Aguardando fechamento", value: "AGUARDANDO_FECHAMENTO"},
            { label: "Finalizada", value: "FINALIZADA" },
        ]
    }
    getStatusLabel(value: string) {
        return this.getListStatus().find(status => status.value === value)?.label;
    }

    getListTipoItem() {
        return [
            { label: "Entrega", value: "ENTREGA" },
            { label: "Coleta", value: "COLETA" }
        ]
    }
    getTipoItemLabel(value: string) {
        return this.getListTipoItem().find(status => status.value === value)?.label;
    }

    getListItemStatus() {
        return [
            { label: "Criado", value: "CRIADO" },
            { label: "Em andamento", value: "EM_ANDAMENTO" },
            { label: "Finalizado", value: "FINALIZADO" },
        ]
    }
    getStatusItemLabel(value: string) {
        return this.getListItemStatus().find(status => status.value === value)?.label;
    }

}

export default RotaService;